import { fabricPanelFixStyle } from '@bingads-webui-campaign-react/common-styles';

export const getStyles = () => ({
  gridContainer: ({
    cellsNumberPerRow,
  }) => ({
    display: 'grid',
    gridTemplateColumns: `repeat(${cellsNumberPerRow}, 1fr)`,
    gridGap: 24,
    marginTop: 16,
  }),
  cellContainer: ({
    cellHeight,
  }) => ({
    boxShadow: '0px 0.6px 1.8px rgba(0, 0, 0, 0.1), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)',
    borderRadius: 6,
    padding: '12px 12px 16px 16px',
    width: 644,
    height: cellHeight,
  }),
});

export const getPanelStyle = () => {
  const styles = {
    footer: {
      ...fabricPanelFixStyle().footer,
    },
    commands: {
      ...fabricPanelFixStyle().commands,
      paddingTop: 18,
      paddingBottom: 11,
    },
  };
  return styles;
};
